import DataTable from "react-data-table-component";

export function DeliveryNoteValidation({
  productFamilyName,
  list,
  columns,
  summaryColumns,
  summaryData,
}) {
  return (
    <>
      {list.length > 0 && (
        <div className="delivery-note-table-info-container">
          <div className="opt-table-title">
            {productFamilyName} ({list.length})
          </div>
          <div className="store-products-table delivery-note-table">
            <DataTable
              columns={columns}
              data={list}
              noDataComponent="No hay datos disponibles."
              className="custom-datatable non-interactive"
              selectableRows={false}
            />
            <DataTable
              columns={summaryColumns}
              data={summaryData}
              className="custom-datatable summary-row no-header-datatable"
              noDataComponent="No hay datos disponibles."
              noHeader
            />
          </div>
        </div>
      )}
    </>
  );
}
